<template>
    <v-dialog v-model="isOpen" max-width="600" scrollable>
        <v-card>
            <v-card-title class="d-flex align-center pa-4">
                <v-icon left :color="hasErrors ? 'warning' : 'success'">
                    {{ hasErrors ? "mdi-alert-circle-outline" : "mdi-check-circle-outline" }}
                </v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                    {{ hasErrors ? t.partialSuccess : t.success }}
                </span>
                <v-spacer />
                <v-btn icon small @click="isOpen = false">
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-divider />

            <v-card-text class="pa-0" style="max-height: 400px">
                <div v-if="successCount > 0" class="pa-4 pb-2">
                    <div class="d-flex align-center">
                        <v-icon small color="success" left>mdi-check</v-icon>
                        <span class="text-body-2 success--text font-weight-medium">
                            {{ successCount }} {{ t.itemsSucceeded }}
                        </span>
                    </div>
                </div>

                <div v-if="hasErrors" class="pa-4 pt-2">
                    <div class="d-flex align-center mb-2">
                        <v-icon small color="warning" left>mdi-alert</v-icon>
                        <span class="text-body-2 warning--text font-weight-medium">
                            {{ errors.length }} {{ t.itemsFailed }}
                        </span>
                    </div>
                    <v-list dense class="pa-0 rounded" style="background: #fff8e1">
                        <v-list-item
                            v-for="([id, msg], index) in errors"
                            :key="index"
                            class="px-3"
                            style="min-height: 40px; border-bottom: 1px solid rgba(0,0,0,0.06)"
                        >
                            <v-list-item-icon class="mr-2 my-auto">
                                <v-icon small color="warning">mdi-alert-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="text-body-2 font-weight-bold">
                                    {{ id }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-caption" style="white-space: normal">
                                    {{ msg }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </div>
            </v-card-text>

            <v-divider />

            <v-card-actions class="pa-3 justify-end">
                <v-btn text color="primary" @click="isOpen = false">
                    {{ t.close }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const TRANSLATIONS = {
    en: {
        partialSuccess: "Bulk action completed with errors",
        success: "Bulk action completed",
        itemsSucceeded: "item(s) succeeded",
        itemsFailed: "item(s) failed",
        close: "Close",
    },
    fr: {
        partialSuccess: "Action groupée terminée avec des erreurs",
        success: "Action groupée terminée",
        itemsSucceeded: "élément(s) réussi(s)",
        itemsFailed: "élément(s) en erreur",
        close: "Fermer",
    },
};

export default {
    name: "BulkResultDialog",
    props: {
        errors: {
            type: Array,
            default: () => [],
        },
        successes: {
            type: Array,
            default: () => [],
        },
        locale: {
            type: String,
            default: "en",
        },
    },
    data() {
        return {
            isOpen: true,
        };
    },
    computed: {
        t() {
            return TRANSLATIONS[this.locale] || TRANSLATIONS.en;
        },
        hasErrors() {
            return this.errors.length > 0;
        },
        successCount() {
            return this.successes.length;
        },
    },
    watch: {
        isOpen(val) {
            if (!val) {
                this.$nextTick(() => {
                    if (this.$el && this.$el.parentNode) {
                        this.$el.parentNode.removeChild(this.$el);
                    }
                    this.$destroy();
                });
            }
        },
    },
};
</script>
